import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule } from '@angular/platform-browser';

import { STORE_PREFIX } from '@frontend/vanilla/core';
import { GlobalSearchModule } from '@globalsearch/productstub';
import * as Hammer from 'hammerjs';

class HammerConfig extends HammerGestureConfig {
    override overrides = {
        swipe: { enable: true, direction: Hammer.DIRECTION_ALL },
        pan: { enable: true, direction: Hammer.DIRECTION_ALL },
    } as any;
}

export function provideMokaBingo(): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: STORE_PREFIX, useValue: 'bingo.' },
        { provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig },
        importProvidersFrom(HammerModule, GlobalSearchModule.forRoot()),
    ]);
}
